import "./physicianDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import PhysicianDetailsEditComponent from "./physician-details-edit/physicianDetailsEditComponent";
import PhysicianDetailsViewComponent from "./physician-detials-view/physicianDetailsViewComponent";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import {ImageConfig} from "../../../../constants";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";

interface PhysicianDetailsViewEditComponentProps {
    facilityDetails: any;
    onModeChange: Function;
    canEdit: boolean;
}

const PhysicianDetailsViewEditComponent = (props: PhysicianDetailsViewEditComponentProps) => {

    const {facilityDetails, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [facilityId, setFacilityId] = useState<any>(undefined);
    const [physicianList, setPhysicianList] = useState<any>([]);
    const [isPhysicianListLoading, setIsPhysicianListLoading] = useState<boolean>(false);
    const [isPhysicianListLoaded, setIsPhysicianListLoaded] = useState<boolean>(false);
    const [isPhysicianListLoadingFailed, setIsPhysicianListLoadingFailed] = useState<boolean>(false);

    const handlePhysicianDetailsUpdate = useCallback((updatedPhysicianList: any) => {
        setPhysicianList(updatedPhysicianList);
    }, []);

    useEffect(() => {
        if (facilityDetails) {
            setFacilityId(facilityDetails.id);
        }
    }, [facilityDetails]);

    const handlePhysicianDetailsEditCancel = useCallback((physicianList: any) => {
        setPhysicianList(physicianList)
        setMode("view");
    }, []);

    const getPhysicainList = useCallback(() => {
        const payload = {};
        setIsPhysicianListLoading(true);
        setIsPhysicianListLoaded(false);
        setIsPhysicianListLoadingFailed(false);
        CommonService._facility.getPhysicianList(facilityId, payload)
            .then((response: IAPIResponseType<any>) => {
                setPhysicianList(response.data || []);
                setIsPhysicianListLoading(false);
                setIsPhysicianListLoaded(true);
                setIsPhysicianListLoadingFailed(false);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while Fetching physician list from the facility`, "error");
                setIsPhysicianListLoading(false);
                setIsPhysicianListLoaded(false);
                setIsPhysicianListLoadingFailed(true);
            })
    }, [facilityId]);

    useEffect(() => {
        if (facilityId) {
            getPhysicainList();
        }
    }, [facilityId, getPhysicainList]);

    useEffect(() => {
        onModeChange(mode);
    }, [mode, onModeChange]);

    return (
        <div className={'physician-details-view-edit-component details-tab-data-wrapper'}>
            {
                isPhysicianListLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isPhysicianListLoadingFailed && <StatusCardComponent title={'Failed to load status'}/>
            }
            {
                isPhysicianListLoaded && <>
                    {
                        mode === "view" && <PhysicianDetailsViewComponent
                            facilityId={facilityDetails.id}
                            physicianList={physicianList}
                            canEdit={canEdit}
                            onEditModeOpen={() => {
                                setMode("edit")
                            }}
                            onUpdateComplete={handlePhysicianDetailsUpdate}
                        />
                    }
                    {
                        mode === "edit" && <PhysicianDetailsEditComponent
                            physicianDetailsList={physicianList}
                            facilityId={facilityDetails.id}
                            onUpdateComplete={handlePhysicianDetailsUpdate}
                            onEditCancel={handlePhysicianDetailsEditCancel}
                        />
                    }
                </>
            }
        </div>
    );

};

export default PhysicianDetailsViewEditComponent;
